import React, { createContext, useContext, useState } from 'react';
import { translations2025, translations2026, Language, TranslationType } from '../translations';
import { useLocation } from 'react-router-dom';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string | string[];
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguage] = useState<Language>('fr');

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t: () => '' }}>
      <LanguageConsumer language={language} setLanguage={setLanguage}>
        {children}
      </LanguageConsumer>
    </LanguageContext.Provider>
  );
}

function LanguageConsumer({ children, language, setLanguage }: { children: React.ReactNode; language: Language; setLanguage: (lang: Language) => void }) {
  const location = useLocation();
  const is2025 = location.pathname.startsWith('/2025');
  const translations = is2025 ? translations2025 : translations2026;

  const t = (key: string): string | string[] => {
    return translations[language][key as keyof TranslationType] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
